// import createReactClass from 'create-react-class';
// import _ from 'lodash';
// import React from 'react';
// import InputMixin from '../../../../mixins/input-mixin';
// import NumericMixin from '../../../../mixins/numeric-mixin';
// import PublishMixin from '../../../../mixins/publish-mixin';

import FieldInteger from 'bz-core-controls/controls/form/field/field-integer';

// const Integer = createReactClass({
//   displayName: 'Integer',
//   mixins: [PublishMixin, InputMixin('input'), NumericMixin],

//   getInitialState: function () {
//     this.input = React.createRef();
//     return { caret: -1 };
//   },

//   getDefaultProps: function () {
//     return {
//       value: 0,
//       min: 0
//     };
//   },

//   getInputNode: function () {
//     return this.input.current;
//   },

//   componentDidUpdate: function (next) {
//     if (this.state.caret > -1) {
//       this.select(this.state.caret);
//       this.setState({ caret: -1 });
//     }
//   },

//   onChange: function (e) {
//     if (
//       this.props.allowNull === true &&
//       (e.target.value === null || e.target.value === undefined || e.target.value === '')
//     ) {
//       this.publish(null);
//     } else {
//       let val = this.toInteger(e.target.value, e.target.selectionStart);
//       val = this.limit(val, this.props.min, this.props.max);
//       this.publish(val);
//     }
//   },

//   onMouseUp(e) {
//     e.preventDefault();
//   },

//   onKeyUp(e) {
//     switch (e.keyCode || e.which) {
//       case 38: //backspace
//         e.preventDefault();
//         e.stopPropagation();
//         return this.increment();
//       case 40:
//         e.preventDefault();
//         e.stopPropagation();
//         return this.decrement();
//     }
//   },

//   onFocus(e) {
//     this.select(0, e.target.value.length);
//     if (this.props.onFocus) this.props.onFocus(e);
//   },

//   increment() {
//     let val = parseInt(this.get());
//     if (isNaN(val) === false) {
//       val = this.limit(val + 1, this.props.min, this.props.max);
//       this.publish(val);
//     }
//   },

//   decrement() {
//     let val = parseInt(this.get());
//     if (isNaN(val) === false) {
//       val = this.limit(val - 1, this.props.min, this.props.max);
//       this.publish(val);
//     }
//   },

//   render() {
//     let val;
//     if (this.props.allowNull === false) {
//       val = parseInt(this.get());
//     } else {
//       val = this.get();
//     }

//     let style = _.extend({}, { textAlign: 'right' }, this.props.style, this.props.inputStyle);

//     if (this.props.readOnly) return <strong className={this.props.readOnlyClassName}>{val}</strong>;

//     let disabled = false;

//     if (this.props.disabled != undefined && this.props.disabled != false) {
//       disabled = true;
//     }
//     return (
//       <input
//         disabled={disabled}
//         type="text"
//         ref={this.input}
//         pattern="[0-9]*"
//         style={style}
//         value={val}
//         readOnly={this.props.readOnly}
//         onFocus={this.onFocus}
//         onBlur={this.props.onBlur}
//         onKeyUp={this.onKeyUp}
//         onChange={this.onChange}
//         onMouseUp={this.onMouseUp}
//       />
//     );
//   }
// });

// export default Integer;

export default function Integer({ style, ...props }) {
  return <FieldInteger className="inline w-20 mx-1" {...props} />;
}
